import { ContentType, Component, Field, Project } from 'contensis-core-api';
import ContentTypeHelper from '~/util/content-type/ContentTypeHelper';

export default (
  contentType: ContentType | Component | undefined,
  targetProject: Project,
  readOnlyFields = false,
  stubAsset = false
) => {
  if (!contentType) return contentType;
  const { assert, transform } = ContentTypeHelper;

  const isContentType = assert.isContentType(contentType);

  const ctLanguage =
    ('defaultLanguage' in contentType
      ? contentType.defaultLanguage
      : Object.keys(contentType.name)[0]) || 'en-GB';

  const defaultLanguage = targetProject.primaryLanguage || ctLanguage;

  const { fields, groups } = transform.TransformLanguageCodes(
    contentType,
    ctLanguage,
    defaultLanguage
  ) as ContentType & { groups: any };

  const description = contentType.description?.[ctLanguage];

  const mappedFields = readOnlyFields
    ? transform.TransformReadOnlyFields(fields)
    : fields;

  const mappedContentType = {
    ...contentType,
    uuid: undefined,
    id: contentType.id,
    name: {
      [defaultLanguage]: contentType.name[ctLanguage],
    },
    description: description
      ? {
          [defaultLanguage]: description,
        }
      : undefined,
    defaultLanguage: isContentType ? defaultLanguage : undefined,
    projectId: targetProject.id,
    fields: mappedFields,
    defaultParentNodeId: undefined,
    groups,
    supportedLanguages: targetProject.supportedLanguages,
  } as unknown as ContentType | Component;

  if (stubAsset) {
    mappedContentType.fields = [
      {
        id: 'migrationIncomplete',
        dataType: 'string',
        name: { [defaultLanguage]: '__migration_incomplete__' },
        description: {},
        validations: {},
        groupId: isContentType ? 'main' : undefined,
      },
    ] as unknown[] as Field[];
    if (isContentType) {
      (mappedContentType as any).groups = [
        {
          id: 'main',
          name: {
            [defaultLanguage]: 'Main',
          },
        },
      ];
      (mappedContentType as ContentType).entryTitleField =
        'migrationIncomplete';
      (mappedContentType as any).entryDescriptionField = undefined;
      (mappedContentType as any).entryThumbnailField = undefined;
    }
  }

  return mappedContentType;
};
